import {ReactNode} from "react";
import classNames from "classnames";
import {FooterNavItemType} from "../../model/types";
import {FooterLink} from "../FooterLink/FooterLink";
import {Svg} from "@/shared/ui/Svg";
import styles from "../Footer.module.scss";

type Props = {
    item: FooterNavItemType;
    opened: boolean;
    onToggle: () => void;
    children?: ReactNode;
};

export const FooterNavItem = (
    {
        item,
        opened,
        onToggle,
        children,
    }: Props
) => {
    return (
        <div className={styles.navItem}>
            <div className={styles.navItemTitleContainer}>
                {item.href ? (
                    <FooterLink href={item.href} className={styles.navItemTitleLink}>{item.title}</FooterLink>
                ) : (
                    <p className={styles.navItemTitle}>{item.title}</p>
                )}
                <button
                    type="button"
                    className={classNames(styles.navItemIcon, {[styles.down]: opened})}
                    onClick={onToggle}
                >
                    <Svg id={`arrowDown`} className={styles.navItemIconSvg} />
                </button>
            </div>
            <div className={classNames(styles.navItemContentContainer, {[styles.visible]: opened})}>
                <div className={styles.navItemContent}>
                    {item.links.map((link) => (
                        <FooterLink
                            key={link.href}
                            href={link.href}
                            external={link.external}
                            className={styles.navItemLink}
                        >
                            {link.title}
                        </FooterLink>
                    ))}
                </div>
            </div>
            {children}
        </div>
    );
};
